// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort[data-v-d4db202a]:before{border:2px solid var(--colorGrayLight);border-radius:50%;content:\"\";display:inline-block;height:20px;margin-right:15px;position:relative;top:3px;width:20px}.is-active.sort[data-v-d4db202a]:before{border:7px solid var(--colorAction)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
